// var languageType = require('./languageCommon.js')
var languageType = require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'

if(language=='zh-CN'){
    document.getElementsByTagName('meta')[1].setAttribute('content',florameta[language])
    document.getElementsByTagName('meta')[2].setAttribute('content',florakey[language])
    document.title = floratitle[language];
}else{
    document.getElementsByTagName('meta')[1].setAttribute('content',florameta['USA'])
    document.getElementsByTagName('meta')[2].setAttribute('content',florakey['USA'])
    document.title = floratitle['USA'];
    // document.getElementsByTagName('title')[1].setAttribute('content',grouptitle['USA'])
}
$('.commonlanguage').html(commonlanguage[language])
$('title').html(flowerBuildingTitle[language]);
$('.commonHomePage').html(commonHomePage[language]);
$('.commonLvyue').html(commonLvyue[language]);
$('.commonAboutLvyue').html(commonAboutLvyue[language]);
$('.commonlvyueBrand').html(commonlvyueBrand[language]);
$('.commonFlowerConstruction').html(commonFlowerConstruction[language]);
$('.commonFloralLux').html(commonFloralLux[language]);
$('.commonClaim').html(commonClaim[language]);
$('.commonWeiLai').html(commonWeiLai[language]);
$('.commonTanChen').html(commonTanChen[language]);
$('.commonflowerTravel').html(commonflowerTravel[language]);
$('.commonJoinInCooperation').html(commonJoinInCooperation[language]);
$('.commonPanorama').html(commonPanorama[language]);
// $('.commonPaidInformation').html(commonPaidInformation[language]);
$('.commonZh').html(commonZh[language]);
$('.commonUsa').html(commonUsa[language]);
$('.commonJp').html(commonJp[language]);
$('.commonKo').html(commonKo[language]);
$('.commonTh').html(commonTh[language]);
$('.commonYh').html(commonYh[language]);
$('.commonReservations a').html(commonReservations[language]);
$('.commonClose').html(commonClose[language]);
$('.commonFreebooking').html(commonFreebooking[language]);
$('.commonDownload').html(commonDownload[language]);
$('.commonWechatSubscription').html(commonWechatSubscription[language]);
$('.commonHuazhuSubscription').html(commonHuazhuSubscription[language]);
$('.commonBrandintroductio').html(commonBrandintroductio[language]);
$('.commonWantJoin').html(commonWantJoin[language]);
$('.commonConectUs').html(commonConectUs[language]);
$('.commonCustomerServiceHotline').html(commonCustomerServiceHotline[language]);
$('.commonConectChina').html(commonCustomerServiceHotlineChina[language]);
$('.commonConectPhilippines').html(commonCustomerServiceHotlinePhilippines[language]);
$('.commonConectJapan').html(commonCustomerServiceHotlineJapan[language]);
$('.commonConectKorea').html(commonCustomerServiceHotlineKorea[language]);
$('.commonConectThailand').html(commonCustomerServiceHotlineThailand[language]);
$('.commonConectYh').html(commonCustomerServiceHotlineYh[language]);
$('.commonCompanyInfo').html(commonCompanyInfo[language]);
$('.commonCompanyBeianInfo').html(commonCompanyBeianInfo[language]);
$('.commonCompanyBeianText').html(commonCompanyBeianText[language]);
$('.commonCompanyLicense').html(commonCompanyLicense[language]);
$('.commonCompanyICP').html(commonCompanyICP[language]);
$('.flowerBuildingDesign').html(flowerBuildingDesign[language]);
$('.flowerBuildingDesignType1').html(flowerBuildingDesignType1[language])
$('.flowerBuildingDesignType2').html(flowerBuildingDesignType2[language])
$('.flowerBuildingDesignType3').html(flowerBuildingDesignType3[language])
$('.flowerBuildingaboutfb').html(flowerBuildingaboutfb[language])
$('.flowerBuildingaboutfbType1').html(flowerBuildingaboutfbType1[language])
$('.flowerBuildingaboutfbType2').html(flowerBuildingaboutfbType2[language])
$('.flowerBuildingaboutfbType3').html(flowerBuildingaboutfbType3[language])
$('.flowerBuildingBrand1').html(flowerBuildingBrand1[language]);
$('.flowerBuildingBrand2').html(flowerBuildingBrand2[language]);
$('.flowerBuildingBrand3').html(flowerBuildingBrand3[language]);
$('.flowerBuildingBrand4').html(flowerBuildingBrand4[language]);
if (language === 'USA') {
  $('.J_flowerBuildingInfoItem:not(:first-child)').show()
  $('.flowerBuildingBrandPhilippines').html(flowerBuildingBrandPhilippines[language]);
  $('.flowerBuildingBrandJapan').html(flowerBuildingBrandJapan[language]);
  $('.flowerBuildingBrandKorea').html(flowerBuildingBrandKorea[language]);
  $('.flowerBuildingBrandThailand').html(flowerBuildingBrandThailand[language]);
}
$('.flowerBuildingBrand1Info').html(flowerBuildingBrand1Info[language])
$('.flowerBuildingBrand1Introduction').html(flowerBuildingBrand1Introduction[language])
$('.flowerBuildingBrand2Info').html(flowerBuildingBrand2Info[language])
$('.flowerBuildingBrand2Introduction').html(flowerBuildingBrand2Introduction[language])
$('.flowerBuildingBrand3Info').html(flowerBuildingBrand3Info[language])
$('.flowerBuildingBrand3Introduction').html(flowerBuildingBrand3Introduction[language])
$('.flowerBuildingBrand4Info').html(flowerBuildingBrand4Info[language])
$('.flowerBuildingBrand4Introduction').html(flowerBuildingBrand4Introduction[language])
$('.flowerBuildingSenseTitle').html(flowerBuildingSenseTitle[language])
$('.flowerBuildingSixFeeling1').html(flowerBuildingSixFeeling1[language]);
$('.flowerBuildingSixFeeling2').html(flowerBuildingSixFeeling2[language]);
$('.flowerBuildingSixFeeling3').html(flowerBuildingSixFeeling3[language]);
$('.flowerBuildingSixFeeling4').html(flowerBuildingSixFeeling4[language]);
$('.flowerBuildingSixFeeling5').html(flowerBuildingSixFeeling5[language]);
$('.flowerBuildingSixFeeling6').html(flowerBuildingSixFeeling6[language]);
$('.flowerBuildingSixFeeling7').html(flowerBuildingSixFeeling7[language]);
$('.flowerBuildingSixFeeling1Info').html(flowerBuildingSixFeeling1Info[language]);
$('.flowerBuildingSixFeeling2Info').html(flowerBuildingSixFeeling2Info[language]);
$('.flowerBuildingSixFeeling3Info').html(flowerBuildingSixFeeling3Info[language]);
$('.flowerBuildingSixFeeling4Info').html(flowerBuildingSixFeeling4Info[language]);
$('.flowerBuildingSixFeeling5Info').html(flowerBuildingSixFeeling5Info[language]);
$('.flowerBuildingSixFeeling6Info').html(flowerBuildingSixFeeling6Info[language]);
$('.flowerBuildingSixFeeling7Info').html(flowerBuildingSixFeeling7Info[language]);
$('.commonLvyue1').html(commonLvyue1[language]);
$('.Leadership').html(Leadership[language]);
$('.TalentRecruitment').html(TalentRecruitment[language]);
$('.floralReservation').html(floralReservation[language]);
$('.commonBaina').html(commonBaina[language]);
$('.commonBanlan').html(commonBanlan[language]);



/** WEBPACK FOOTER **
 ** ./src/js/flowerBuildingLanguage.js
 **/